import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { Router } from '@angular/router';
import { AppService } from './app.service';
import { StorageService } from './storage.service';
import { TranslateService } from '../../services/translate.service';
import { UtilService } from '../../services/util.service';

@Injectable({ providedIn: 'root' })
export class AuthenticationService {
    public currentUserSubject: BehaviorSubject<any>;
    public currentUser: Observable<any>;
    public currentUserKey: string = 'currentUser';

    constructor(
        private router: Router,
        public appService: AppService,
        public storageService: StorageService,
        public utilService: UtilService,
        private translateService: TranslateService
    ) {

        if (this.appService.getSessionId()) {
            storageService.getData(this.currentUserKey, (currentUser) => {
                this.currentUserSubject = new BehaviorSubject<any>(currentUser);
                this.currentUser = this.currentUserSubject.asObservable();
            });
        } else {
            this.currentUserSubject = new BehaviorSubject<any>(null);
            this.currentUser = this.currentUserSubject.asObservable();
        }
    }

    public get currentUserValue(): any {
        return this.currentUserSubject.value;
    }

    setUser(user) {
        if (this.utilService.isMobile()) {
            this.appService.writeCookie("loggedin", true, 30);//setting which will expire after 30 days(30 needs to config driven: TODO)
        } else if (user.user_type=="kiosk_user") { //kiosk user 30 days validity 365 days validity for logeedin true for kiosk user 
            this.appService.writeCookie("loggedin", true, 365);
            // localStorage.setItem("loggedin","true");
        } else {
            this.appService.writeCookie("loggedin", true, 0);//setting which will expire after browser close
        }

        var obj = {};
        for (let key of ['user_id', 'id', 'first_name', 'user_type', 'login_id', 'account_url', 'isPasswordExpired', 'role', 'role_type', 'super_app_url']) {
            obj[key] = user[key];
        }
        this.storageService.setData(this.currentUserKey, obj, () => {
            this.currentUserSubject.next(user);
        });
    }

    getCurrentUser() {
        var getUser: any;
        //I have not used storage service here becuase it will break everywhere if we use callback 
        //and we are always going to use localstorage for session storage
        getUser = localStorage.getItem(this.currentUserKey);
        try {
            getUser = JSON.parse(getUser)
            return getUser;
        } catch (e) {
            return '';
        };
    }
    getSessionId() {
        return this.appService.getSessionId();
    }
    getUserType() {
        var user = this.getCurrentUser();
        if (user && user.user_type != undefined) {
            return user.user_type;
        } else {
            return false;
        }
    }

    getEnryptionKey() {
        return this.appService._currentSessionData.encryptKey;
    }
    logout(callback) {
        // remove user from local storage to log user out
        // deleteNotification
        let local_language = localStorage.getItem("appLanguage");
        let adConfigs = localStorage.getItem(this.appService._currentKeys.adConfigs);
        let authenticationType = localStorage.getItem(this.appService._currentKeys.authenticationType);
        if (local_language == undefined || local_language == "")
            local_language = "en"
        this.storageService.removeData(this.currentUserKey, () => {
            this.currentUserSubject.next(null);
            let curr_epres = this.storageService.getSessionStorageDataSync('current_EPrescription');
            let curr_clin = this.storageService.getSessionStorageDataSync('current_clinical');
            let curr_med = this.storageService.getSessionStorageDataSync('current_medication');
            let curr_epres_unsaved_forms = this.storageService.getSessionStorageDataSync('curr_epres_unsaved_forms');
            this.storageService.clearAllStorage(() => {
                //this.translateService.defaultLanguageCode
                if(curr_epres != null && curr_epres)
                    this.storageService.setSessionStorageData('current_EPrescription', curr_epres,()=>{});
                if(curr_clin != null && curr_clin)
                    this.storageService.setSessionStorageData('current_clinical', curr_clin,()=>{});
                if(curr_med != null && curr_med)
                    this.storageService.setSessionStorageData('current_medication', curr_med,()=>{});
                try {
                    if(curr_epres_unsaved_forms!=null && curr_epres_unsaved_forms){
                        this.storageService.setSessionStorageData('curr_epres_unsaved_forms', curr_epres_unsaved_forms,()=>{});}
                } catch (error) {
                    
                }
    
                this.translateService.setLanguage(local_language, () => {
                    this.appService.logout(() => {
                        if(adConfigs != null){
                            if(authenticationType != null && this.appService.setAuthenticationConfig != undefined){
                                this.appService.setAuthenticationConfig(authenticationType, JSON.parse(adConfigs));
                            }else{
                                this.appService.setAdConfig(JSON.parse(adConfigs));
                            }
                        }
                        callback();
                    });
                });
            });
        });
    }
}

// export class User {
//     session_d: string;
//     id: number;
//     username: string;
//     password: string;
//     firstName: string;
//     lastName: string;
//     token?: string;
//     mobile_no: string;
//     first_name: string;
// }